import { apiClient } from '../store/store';

// Konten DokumentasiBagian.isi bisa berisi <img src="/media/..."> RELATIF
// (dari skrip migrasi awal yang jalan lewat manage.py shell, bukan lewat
// serializer DRF yang otomatis bikin absolute URI via request.build_absolute_uri()).
// Path relatif begitu, kalau dirender apa adanya di frontend, akan coba
// diambil dari origin FRONTEND (mis. localhost:3000/media/...) yang tidak
// ada isinya - gambar backend selalu di origin BACKEND (port/domain beda).
// Fungsi ini menormalkan SEMUA src="/media/..." jadi absolute ke backend,
// idempotent (aman dipanggil berkali-kali - src yang sudah absolute
// (http://...) tidak disentuh).
export function resolveMediaUrls(html) {
	if (!html) return html;
	const base = (apiClient.defaults.baseURL || '').replace(/\/$/, '');
	if (!base) return html;
	return html.replace(/src="\/media\//g, `src="${base}/media/`);
}
